
import IDENTITY from "../../../../public/assets/js/identity";
let functionList = {
  jobRoute: ['JobList', 'ReviewJob'],
  resumeRoute: ['Resume', 'TalentList'],
  userRoute: ['ExpensionCompany', 'CompanyDetail', 'AccountCenter'],

  // 手机正则
  phoneExg: /^1[3456789]\d{9}$/,
  // 邮箱正则
  mailReg: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
  
  // 判断手机号格式
  judgePhoneFormat(num){
    return this.phoneExg.test(num) ? true : false;
  },
  // 判断邮箱正则
  judgeMailFormat(num) {
    return this.mailReg.test(num) ? true : false;
  },
  // 判断输入框内格式并提供相应警告
  judgeInputFormat(v, isMust = false, t){
    let val = v.value;
    let result = null;
    switch(t){
      case "phone":
        result = this.judgePhoneFormat(val);
        break;

      case "cert":
        result = this.judgeCertFormat(val);
        break;  

      case "mail":
        result = this.judgeMailFormat(val);
        break;

      default:
        if(isMust){
          result = val ? true : false;
        }else{
          result = true;
        }  
    }
    return result;
    
  },
  // 集合验证
  identityValue(_this, data, type = "empty") {
    return (function () {
      const val = typeof data.value === 'string' ? data.value.trim() : data.value;
      let access = false;
      if (type === "empty") {
        access = val ? true : false;

      } else if (type === "mail") {
        access = IDENTITY.identityMail(val);

      } else if (type === "phone") {
        access = IDENTITY.identityPhone(val);

      } else if (type === "cert") {
        access = IDENTITY.identityCert(val);

      } else {
        return access;
      }
      // 显示提示
      this.$set(data, "check", !access);
      return access;
    }).call(_this);
  },
}

export default functionList;
